module.exports = __webpack_public_path__ + "img/image (1).374522d9.svg";